import React from 'react';
import './TopBar.scss';

import { Icon } from '../../atoms/Icon/Icon';
import { SignInButton } from '../SignInButton/SignInButton';
import { useReactiveVar } from '@apollo/client';
import { loggedUserTypeVar } from '../../../App';

export const TopBar = (props) => {
  const { } = props;
  const loggedUserType = useReactiveVar(loggedUserTypeVar)
  return (
    <div className='top-bar'>
      <div className='icon-container' onClick={() => { window.location.href = "https://www.constlending.com"; }}>
        <Icon svgFilePath={"./assets/icons/constlending-logo.svg"} />
      </div>
      <div className='right-container'>
        <span className="question">Questions? (203) 423-3534</span>
        {!loggedUserType &&
          <SignInButton />
        }
      </div>
    </div>
  );
}
